import React from 'react';
import type { MtgCheckItem } from '../types/meeting';

interface MtgCheckListProps {
  mtgChecks: MtgCheckItem[];
  templateName?: string;
  onShowMasterPage: () => void;
}

const MtgCheckList: React.FC<MtgCheckListProps> = ({
  mtgChecks,
  templateName,
  onShowMasterPage,
}) => {
  return (
    <div className="panel-section">
      <div className="section-title">
        <span className="section-icon material-symbols-outlined">checklist</span>
        <span className="section-title-text" id="mtg-check-title">
          {templateName || 'MTGチェック'}
        </span>
        <div className="section-action material-symbols-outlined" onClick={onShowMasterPage}>
          tune
        </div>
      </div>
      <div className="checklist-container">
        {mtgChecks.length === 0 ? (
          <div className="empty-state">
            <span className="material-symbols-outlined empty-state-icon">checklist</span>
            <div className="empty-state-text">
              MTGチェックテンプレートが選択されていません。設定から選択してください。
            </div>
          </div>
        ) : (
          mtgChecks.map((item) => (
            <div
              key={item.id}
              className={`checklist-item ${item.completed ? 'has-checked' : ''}`}
            >
              <div className="checklist-item-header">
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={item.completed}
                  readOnly
                />
                <span className="checklist-text">{item.text}</span>
              </div>
              {item.note && <div className="checklist-answer">{item.note}</div>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MtgCheckList;
